export function isWithinLastThreeDays(dateString) {
  const inputDate = new Date(dateString);
  const today = new Date();

  if (isNaN(inputDate.getTime())) {
    return false;
  }

  const inputDateUTC = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
  const todayUTC = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  const diffInTime = todayUTC.getTime() - inputDateUTC.getTime();
  const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

  return diffInDays >= 0 && diffInDays <= 3;
}